// extracted by mini-css-extract-plugin
export var planActions = "plans-module--planActions--d364e";
export var planInfoContainer = "plans-module--planInfoContainer--bd204";
export var planInfoDescription = "plans-module--planInfoDescription--b759f";
export var planInfoTitle = "plans-module--planInfoTitle--d6a47";